import { config } from "~config";
import { Http } from "./http";

export const adminApiRequest = new Http(config.ADMIN_API_URL);
export const assetsApiRequest = new Http(config.ASSETS_API_URL);
